<app-modal
  [(open)]="open"
  [title]="mode === 'add' ? 'Create Layout Group' : 'Edit Layout Group'"
  size="medium"
  (closed)="onClose()">

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
    <app-form-field
      [error]="form.get('groupId')?.invalid && form.get('groupId')?.touched ? 'Group ID is required.' : null">
      <app-text-input
        label="Group ID"
        placeholder="e.g. group-001"
        formControlName="groupId"
        [invalid]="!!(form.get('groupId')?.invalid && form.get('groupId')?.touched)">
      </app-text-input>
    </app-form-field>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <app-text-input type="date" label="Start Date" formControlName="startDate"></app-text-input>
      <app-text-input type="date" label="End Date" formControlName="endDate"></app-text-input>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <app-text-input type="time" label="Start Time" formControlName="startTime"></app-text-input>
      <app-text-input type="time" label="End Time" formControlName="endTime"></app-text-input>
    </div>

    <app-form-field label="Active Days">
      <div class="flex flex-wrap gap-2">
        @for (day of daysOfWeek; track day) {
          <button type="button"
            (click)="toggleDay(day)"
            [class]="isDaySelected(day)
              ? 'rounded-pill px-3 py-1 text-[13px] font-semibold bg-action text-action-text'
              : 'rounded-pill px-3 py-1 text-[13px] font-semibold bg-sunken text-ink-2 hover:bg-surface-3'">
            {{ day.slice(0, 3) }}
          </button>
        }
      </div>
    </app-form-field>

    <label class="flex items-center gap-2 text-[13px] font-semibold text-ink-2">
      <app-toggle formControlName="isTemplateSlideshow"></app-toggle>
      State Slideshow
    </label>

    @if (form.value.isTemplateSlideshow) {
      <app-number-input
        label="Slideshow Change Period"
        unit="ms"
        placeholder="e.g. 5000"
        formControlName="templateSlideshowChangePeriod">
      </app-number-input>
    }
  </form>

  <ng-template modalFooter>
    <div class="flex flex-1 items-center justify-end gap-2">
      <button type="button" (click)="onClose()"
        class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken">
        Cancel
      </button>
      <button type="button" (click)="onSubmit()" [disabled]="form.invalid"
        class="rounded-control bg-action px-4 py-2 text-[13px] font-semibold text-action-text disabled:opacity-40 hover:brightness-90">
        {{ mode === 'add' ? 'Create' : 'Save' }}
      </button>
    </div>
  </ng-template>
</app-modal>
